import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

// 空アイコン
export default createSvgIcon(<React.Fragment></React.Fragment>, 'Empty');
